export function copyToClipboard(text: string) {
  navigator.clipboard?.writeText(text);
}

type DownloadState = {
  id: string;
  content: string;
  language: string;
  mode: 'displayCode' | 'renderRich';
  options: { showLineNumbers: boolean };
};

export function downloadFile(state: DownloadState, includeLineNumbers = false) {
  const date = new Date().toISOString().slice(0, 10);
  if (state.mode === 'renderRich') {
    const blob = new Blob(
      [`<!doctype html><html><head><meta charset="utf-8"></head><body>\n${state.content}\n</body></html>`],
      { type: 'text/html' }
    );
    const name = `${state.id}-${state.language}-${date}.html`;
    saveBlob(blob, name);
  } else {
    let text = state.content;
    if (includeLineNumbers) {
      text = text
        .split('\n')
        .map((l, i) => `${i + 1}: ${l}`)
        .join('\n');
    }
    const blob = new Blob([text], { type: 'text/plain' });
    const name = `${state.id}-${state.language}-${date}.txt`;
    saveBlob(blob, name);
  }
}

function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
